import axiosIns from '@/plugins/axios'

export default {
  getReports() {
    return axiosIns.get('/waiter/reports')
  },
}
